import styled from "styled-components";

import { Flex } from "../Grid";

const HeaderNavigation = styled(Flex)`
  margin: 0;
  padding: 0;
`;

HeaderNavigation.defaultProps = {
  as: "ul",
  display: ["none", null, "flex"],
  alignItems: "flex-start",
};

export { HeaderNavigation };
